import { BaseModel } from './base.model'
import { Session } from './session.model'
import { Document } from './document.model'
import { Moment } from 'moment'
import { DriverLicense } from './driver-license.model'

export class Driver extends BaseModel<Driver> {
  static DEFAULT_ATTRIBUTES = {
    sessions: new Array<Session>(),
    documents: new Array<Document>()
  }

  sessionsCount: number
  id: number
  sessions: Session[]
  documents: Document[]
  fios: string[]
  phones: string[]
  birthdates: Moment[]
  firstSessionCreated: Moment
  portraitPhotos: {
    id: number
    thumbUrl: string
    url: string
    type: string
  } []
  driverLicenses: DriverLicense[]

  public hasDocuments(): boolean {
    return this.documents.length > 0
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/driver.model.ts